<template>
  <v-container>
    <v-row>
      <template v-for="cat in categories">
        <v-col class="mt-2" cols="12" :key="cat.title">
          <h3 class="primary--text">{{ cat.title }}</h3>
        </v-col>
        <v-col
          cols="6"
          md="2"
          v-for="item in cat.items"
          :key="`${cat.title}${item.title}`"
        >
          <v-card
            :to="item.to ? { name: item.to } : null"
            :href="item.href ? item.href : null"
            :target="item.href ? '_blank' : null"
          >
            <v-img :src="item.image" cover></v-img>

            <v-card-actions>
              <v-btn
                elevation="0"
                small
                tile
                text
                color="primary"
                :to="item.to ? { name: item.to } : null"
                :href="item.href ? item.href : null"
                :target="item.href ? '_blank' : null"
                :title="item.title"
                block
              >
                {{ item.title }}
                <v-icon right>{{ item.icon }}</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </template>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Admin_Modules_Dashboard",

  data: () => ({
    categories: [
      {
        title: "Settings",
        items: [
          {
            title: "Setup",
            image: require("#Components/assets/modules/setup.jpg"),
            icon: "mdi-notebook-multiple",
            to: "app.setup",
          },
        ],
      },
      {
        title: "Other tools",
        items: [
          {
            title: "SEM God",
            image: require("#Components/assets/apps-screenshots/sg.png"),
            icon: "mdi-arrow-top-right-thick",
            href: "https://sg.youniversal.com",
          },
          {
            title: "Admin Tool",
            image: require("#Components/assets/apps-screenshots/ant.png"),
            icon: "mdi-arrow-top-right-thick",
            href: "https://ant.youniversal.com",
          },
        ],
      },
    ],
  }),

  methods: {
    ...mapActions("app", ["updateBreadcrumbs"]),

    initialize() {
      this.updateBreadcrumbs([]);
    },
  },

  mounted() {
    this.initialize();
  },
};
</script>

<style scoped lang="scss">
@import "~@/_variables.scss";

.v-image.v-responsive.theme--light {
  border-bottom: 1px solid $primary;
}
</style>
